export const FIELD_CANT_BE_EDITED_TEXT = "Το πεδίο δεν μπορεί να τροποποιηθεί";
export const WRONG_TEXT = "Λάθος";
export const MOBILE_DEVICES_WIDTH = 960;
export const DEFAULT_ROWS = 6;
